import { render, staticRenderFns } from "./NotificacaoIndex.vue?vue&type=template&id=7ad45010&scoped=true&"
import script from "./NotificacaoIndex.vue?vue&type=script&lang=js&"
export * from "./NotificacaoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad45010",
  null
  
)

export default component.exports